
import { Vue, Component, Prop } from 'vue-property-decorator'
import ChoiceIcon from '~/components/common/icon/ChoiceIcon.vue'

@Component({
  name: 'SurveyPreview',
  components: {
    ChoiceIcon
  }
})

export default class SurveyPreview extends Vue {
  @Prop() title!: string
  @Prop() surveys!: any
}
